import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export const CancelButton = ({ onClick, disabled }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Button
      className={styles.cancelButton}
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
    >
      {t("WORK_ORDER.QUOTATION.ACTIONS.CANCEL")}
    </Button>
  );
};
